
import axios from 'axios';

import {
  defineComponent,
  ref,
  onMounted,
} from 'vue';

import type { Vertical } from '@/types';

export default defineComponent({
  setup() {
    const options = ref<Vertical[]>([]);

    const loading = ref(true);

    onMounted(async () => {
      try {
        const response = await axios.get('/api/v3/verticals/options');

        options.value = response.data.data;
      } finally {
        loading.value = false;
      }
    });

    return {
      options,
      loading,
    };
  },
});
